module.exports = __webpack_public_path__ + "static/img/kf.936751a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/kf.jpg
// module id = YCi5
// module chunks = 1